import * as React from "react";

interface IProps {
    name: string,
    options: any,
    onChange: any,
    onBlur: any,
    className: string,
    value: string,
}

export default class Select2 extends React.Component<IProps, any>{
    private _ref: any;

    componentDidMount() {
        $(this._ref).select2({
            placeholder: "Выберите правооблодателя...",
        });

        $(this._ref).on('change', (e) => {
            this.props.onChange(e)
        });
    }

    componentWillReceiveProps(nextProps: any) {
        $(this._ref).trigger('change.select2');
    }

    render() {
        return (
            <select ref={ref => this._ref = ref} name={this.props.name}
                value={this.props.value} onChange={this.props.onChange}
                onBlur={this.props.onBlur} className={this.props.className} >
                <option value="">Выберите правообладеля...</option>

                {this.props.options.map((author: { user_id: number, full_name: string }, i: number) => {
                    return <option value={author.user_id} key={i}>{author.full_name}</option>
                })}
            </select>
        );
    }
}